import React, { useEffect, useState } from 'react';
import { fetchCourseDetails } from '../../service/certificationAPI';
import { Toast } from '../SoftSkills/Toast';

// SQ 3.19 - 3.31 : Handles the Apply certification.
const ApplyCertificationPopup = ({
    show,
    onClose,
    onSubmit,
    employeeId,
    employeeName,
    domain,
    completedCertifications,
    allowedCertifications,
    appliedCertificates
}) => {

    const [certificateId, setCertificateId] = useState("");
    const [provider, setProvider] = useState("");
    const [clientDependency, setClientDependency] = useState(false);
    const [availableCertificates, setAvailableCertificates] = useState([]);


    useEffect(() => {
        fetchCoursesData();
    }, []);

    const fetchCoursesData = async () => {
        try {
            const payload = {
                currentnumber_of_records: 0,
                page_size: 50,
                search_term: "",
                filter: {
                    practice: "",
                    provider: "",
                    cost: {
                        from: 0,
                        to: 0
                    }
                },
                sort_column: "certificate_name",
                sort_order: 1,
                domain: domain,
            };
            const response = await fetchCourseDetails(payload);
            if (response.status === "success") {
                const filteredCertificates = response?.data?.filter(cert => 
                    !appliedCertificates?.includes(cert.certificateId)
                );
                setAvailableCertificates(filteredCertificates);
            }
        } catch (error) {
            console.error("Error fetching course data:", error);
        }
    };

    const handleCertificateChange = (e) => {
        const selectedId = e.target.value;
        setCertificateId(selectedId);
        const selectedCert = availableCertificates.find(cert => cert.certificateId === selectedId);
        setProvider(selectedCert ? selectedCert.provider : "");
    };

    const handleSubmit = () => {

        const totalCertifications = completedCertifications + 1

        if (totalCertifications > allowedCertifications) {
            if (!clientDependency) {
                onClose();
                Toast.error("Your number of certifications limit is exceeded.")
                return;
            }
        }
            const payload = {
                emp_id: employeeId,
                emp_name: employeeName,
                domain: domain,
                certificate_id: certificateId,
                client_dependency: clientDependency,
                pass_reattempt_status: ""
            };

            onSubmit(payload);
            handleClose();
        
    };

    const handleClose = () => {
        setCertificateId("");
        setProvider("");
        setClientDependency(false);
        onClose();
    };

    if (!show) return null;

    return (
        <div
            className="modal fade show"
            style={{
                display: 'block',
                backgroundColor: 'rgba(0,0,0,0.5)',
                backdropFilter: 'blur(2px)'
            }}
        >
            <div className="modal-dialog certification-modal approval-modal-width">
                <div className="modal-content">
                    {/* Modal Header */}
                    <div className="modal-header">
                        <h6 className="modal-title" id="staticBackdropLabel">
                            Apply Certification
                        </h6>
                        <button
                            type="button"
                            className="btn-close font-12"
                            onClick={handleClose}
                            aria-label="Close"
                        />
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body">
                        <div className="row">
                            {/* Certification Name Dropdown */}
                            <div className="col-md-8 mb-3">
                                <label className="font-12 mb-1 regular-text grey-text d-block">
                                    Certification Name
                                    <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select hive-form-select"
                                    value={certificateId}
                                    onChange={handleCertificateChange}
                                    required
                                >
                                    <option value="">Select</option>
                                    {availableCertificates.map(cert => (
                                        <option key={cert.certificateId} value={cert.certificateId}>
                                            {cert.certificateName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Provider Input (disabled) */}
                            <div className="col-md-4 mb-3">
                                <label className="font-12 mb-1 regular-text grey-text d-block">
                                    Provider
                                    <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    disabled
                                    value={provider}
                                />
                            </div>

                            {/* Client Required Checkbox */}
                            <div className="col-md-8 mt-3">
                                <div className="form-check d-flex align-items-center mb-0 gap-2">
                                    <input
                                        className="form-check-input custom-radio-btn mt-0"
                                        type="checkbox"
                                        checked={clientDependency}
                                        onChange={(e) => setClientDependency(e.target.checked)}
                                        id="clientDependencyCheckbox"
                                    />
                                    <label
                                        className="form-check-label medium-text font-12"
                                        htmlFor="clientDependencyCheckbox"
                                    >
                                        Client Required
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer border-0">
                        <div className="col-md-12 d-flex justify-content-end">
                            <button
                                className="btn hive-btn-secondary me-3"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn hive-btn-primary"
                                onClick={handleSubmit}
                                disabled={!certificateId}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApplyCertificationPopup;